var path = '/401.html';
var html = "<md-card class=has-circle-icon> <md-card-header> <md-card-header-text> <h1 class=\"md-title circle-icon error\">{{::route.title}}</h1> <p class=md-subhead>¯\\_(ツ)_/¯</p> </md-card-header-text> </md-card-header> <md-card-content class=only-buttons> <div layout=row layout-align=center> <md-button class=\"md-primary md-raised\" ng-href={{config.loginRedirectUrl}} flex=100 flex-gt-xs=50> Home </md-button> </div> </md-card-content> </md-card> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./401.html
// module id = 103
// module chunks = 0